"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var ConfirmDialog_1 = __importDefault(require("../ConfirmDialog"));
var UnsavedChangesModal = function (_a) {
    var onCancel = _a.onCancel, onLeave = _a.onLeave, modalTitle = _a.modalTitle, modalDescription = _a.modalDescription, primaryButtonLabel = _a.primaryButtonLabel, secondaryButtonLabel = _a.secondaryButtonLabel;
    return ((0, jsx_runtime_1.jsx)(ConfirmDialog_1.default, { title: modalTitle, description: modalDescription, primaryButton: {
            label: primaryButtonLabel,
            onClick: onLeave,
        }, secondaryButton: {
            label: secondaryButtonLabel,
            onClick: onCancel,
        } }));
};
exports.default = UnsavedChangesModal;
